import React, { useEffect, useState, useCallback } from 'react';
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  deleteDoc,
  doc
} from 'firebase/firestore';
import { db } from '../utils/firebaseConfig';
import { useNavigate } from 'react-router-dom';
import GeneralNavbar from './GeneralNavbar';
import './EmployeeList.css';

const PAGE_SIZE = 10;

function EmployeeList() {
  const [employees, setEmployees] = useState([]);
  const [lastDoc, setLastDoc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('');
  const navigate = useNavigate();

  const fetchEmployees = useCallback(async (reset = false) => {
    setLoading(true);
    try {
      let baseQuery = query(
        collection(db, 'users'),
        where('role', '==', 'employee'),
        orderBy('name'),
        limit(PAGE_SIZE)
      );

      if (!reset && lastDoc) {
        baseQuery = query(baseQuery, startAfter(lastDoc));
      }

      const snapshot = await getDocs(baseQuery);
      const newEmployees = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      if (reset) {
        setEmployees(newEmployees);
      } else {
        setEmployees(prev => [...prev, ...newEmployees]);
      }

      if (snapshot.docs.length < PAGE_SIZE) {
        setLastDoc(null); // No hay más empleados
      } else {
        setLastDoc(snapshot.docs[snapshot.docs.length - 1]);
      }
    } catch (err) {
      console.error('Error cargando empleados:', err);
    }
    setLoading(false);
  }, [lastDoc]);

  useEffect(() => {
    fetchEmployees(true);
  }, [fetchEmployees]);

  const handleEdit = (id) => navigate(`/admin/employees/edit/${id}`);

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de que quieres eliminar este empleado?')) {
      await deleteDoc(doc(db, 'users', id));
      setEmployees(prev => prev.filter(emp => emp.id !== id));
    }
  };

  const handleBack = () => navigate('/admin/');

  const filteredEmployees = employees.filter(emp =>
    (emp.name?.toLowerCase() || '').includes(filter.toLowerCase()) ||
    (emp.apellido?.toLowerCase() || '').includes(filter.toLowerCase()) ||
    (emp.email?.toLowerCase() || '').includes(filter.toLowerCase())
  );

  return (
    <>
      <GeneralNavbar title="Lista de Empleados" onBackClick={handleBack} />
      <div className="employee-list" style={{ marginTop: '80px' }}>
        <div style={{ marginBottom: '16px', textAlign: 'center' }}>
          <input
            type="text"
            placeholder="Buscar por nombre, apellido o email"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            style={{
              padding: '8px',
              width: '90%',
              maxWidth: '400px',
              borderRadius: '4px',
              border: '1px solid #ccc'
            }}
          />
        </div>
        <ul>
          {filteredEmployees.map(emp => (
            <li key={emp.id}>
              <div className="employee-info">
                {emp.name} {emp.apellido} - {emp.email} - "Empleado"
              </div>
              <div className="employee-actions">
                <button onClick={() => handleEdit(emp.id)}>Editar</button>
                <button onClick={() => handleDelete(emp.id)}>Eliminar</button>
              </div>
            </li>
          ))}
        </ul>
        {lastDoc && !loading && (
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <button onClick={() => fetchEmployees()}>Cargar más</button>
          </div>
        )}
        {!lastDoc && !loading && employees.length > 0 && (
          <p style={{ textAlign: 'center', color: '#666' }}>No hay más empleados para mostrar.</p>
        )}
        {loading && <p style={{ textAlign: 'center' }}>Cargando...</p>}
      </div>
    </>
  );
}

export default EmployeeList;

